import { render } from "./DashboardChart.vue?vue&type=template&id=b26bf9be&scoped=true"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"

import "./DashboardChart.vue?vue&type=style&index=0&id=b26bf9be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26bf9be"]])

export default __exports__